import React, { useContext, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from "react-router-dom";
import StudentContext from '../../../context/student-context';
import {getStudentConsentSession,getStudentSelectClusterSession} from '../../../utils/helpers/others/SessionHelper';
import ClusterModal2 from './ClusterModal2';

const SurveyBlockModal = () => {
    const { logout } = useContext(StudentContext);
    const [open,setOpen] = React.useState(false);
    const history = useHistory();
    let studentConsent = getStudentConsentSession();
    let selectCluster = getStudentSelectClusterSession();

    const handleClose = () => {
        setOpen(false);
        history.push("/Survey");
    };

    useEffect (() => {
        if(studentConsent === 'true' && selectCluster === 'true'){
            setOpen(true);
        }
    },[selectCluster,studentConsent])
    
    
    // const handleLogout = async () => await logout();
    const handleLogout = async () => {
        await logout();
    }
    return (
        <div>
            <ClusterModal2 selectCluster={selectCluster} studentConsent={studentConsent}/>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title" className="idletimeoutmodal__dialog__title">
                    <div className="adventurelearn__header">Survey incomplete</div>
                </DialogTitle>
                <DialogContent>
                    <div className="adventurelearn__subheader" style={{ margin: 10, }}>
                        Your AdventureLEARN journey is about to begin, and we're thrilled for you! Complete the survey to unlock access. 
                        Your survey completion is essential for tailoring content to your learning journey. 
                        Let's make it amazing together!
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} className="adventurelearn__dialogOk">
                        Go to Survey
                    </Button>
                    <Button onClick={handleLogout} className="adventurelearn__dialogCancel">
                        Logout
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export { SurveyBlockModal as default }